"use strict";
'use client';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _classnames = _interopRequireDefault(require("classnames"));
var _fuzzyset = _interopRequireDefault(require("fuzzyset"));
var _debounce = _interopRequireDefault(require("lodash/debounce"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireWildcard(require("react"));
var _errorConstants = _interopRequireDefault(require("../../constants/errorConstants"));
var _Button = require("../../elements/button/Button");
var _getDidYouMeanSuggestion = _interopRequireDefault(require("../../form/helpers/getDidYouMeanSuggestion"));
var _staticContentPropCheck = _interopRequireDefault(require("../../utils/content/staticContentPropCheck"));
var _FormFieldErrorMessage = _interopRequireDefault(require("../form-field-error-message/FormFieldErrorMessage"));
var _formFieldModule = _interopRequireDefault(require("./form-field.module.scss"));
var _jsxRuntime = require("react/jsx-runtime");
var _excluded = ["element", "id", "label", "className", "hint", "instruction", "description", "sessionCamExclude", "formId", "hideErrors", "submitButton", "extra", "didYouMean", "labelHelperElement", "labelHelperClassName", "input", "highlightError", "meta", "inputWrapperClassName"];
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var FormField = /*#__PURE__*/function (_PureComponent) {
  function FormField(props) {
    var _this;
    _classCallCheck(this, FormField);
    _this = _callSuper(this, FormField, [props]);
    _defineProperty(_this, "onFocus", function (evt) {
      var input = _this.props.input;

      // pass value through to redux-form
      if (evt && evt.target) {
        input.onFocus(evt.target.value);
        return;
      }
      input.onFocus(evt);
    });
    _defineProperty(_this, "onBlur", function (evt) {
      var _this$props = _this.props,
        input = _this$props.input,
        required = _this$props.required;
      var hasBeenClearedByUser = _this.state.hasBeenClearedByUser;
      var value = evt && evt.target ? evt.target.value : evt;
      if (required && !value && !hasBeenClearedByUser) {
        return;
      }
      input.onBlur(value);
    });
    _defineProperty(_this, "processDidYouMean", (0, _debounce["default"])(function (value) {
      _this.setState({
        suggestion: (0, _getDidYouMeanSuggestion["default"])(value, _this.possibleValues, _this.props.didYouMean)
      });
    }, 150));
    _this.state = {
      hasBeenClearedByUser: false,
      suggestion: null
    };
    if (props.didYouMean) {
      // creates a cache of the FuzzySet for use later
      _this.possibleValues = (0, _fuzzyset["default"])(props.didYouMean.set);
    }
    return _this;
  }

  // https://gitlab.com/JohnLewisPartnership/jl-ui/jl-ui-kit/-/issues/227
  _inherits(FormField, _PureComponent);
  return _createClass(FormField, [{
    key: "UNSAFE_componentWillReceiveProps",
    value: function UNSAFE_componentWillReceiveProps(nextProps) {
      var _this$props2 = this.props,
        input = _this$props2.input,
        meta = _this$props2.meta;
      if (meta.active && input.value && !nextProps.input.value) {
        this.setState({
          hasBeenClearedByUser: true
        });
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (this.props.meta.active && !prevProps.meta.submitting && this.props.meta.submitting) {
        var node = document.getElementById(this.props.id);
        if (node) {
          node.blur();
        }
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$props3 = this.props,
        FormElement = _this$props3.element,
        id = _this$props3.id,
        label = _this$props3.label,
        className = _this$props3.className,
        hint = _this$props3.hint,
        instruction = _this$props3.instruction,
        description = _this$props3.description,
        sessionCamExclude = _this$props3.sessionCamExclude,
        formId = _this$props3.formId,
        hideErrors = _this$props3.hideErrors,
        submitButton = _this$props3.submitButton,
        extra = _this$props3.extra,
        didYouMean = _this$props3.didYouMean,
        labelHelperElement = _this$props3.labelHelperElement,
        labelHelperClassName = _this$props3.labelHelperClassName,
        input = _this$props3.input,
        highlightError = _this$props3.highlightError,
        meta = _this$props3.meta,
        inputWrapperClassName = _this$props3.inputWrapperClassName,
        allOtherProps = _objectWithoutProperties(_this$props3, _excluded);
      var suggestion = this.state.suggestion;

      // TODO see if highlightError and hideErrors can be removed
      var hasError = meta.touched && meta.error || highlightError;
      var showError = hasError && !hideErrors;
      var showHint = meta.active && !showError;
      var inputClasses = (0, _classnames["default"])(_defineProperty(_defineProperty({}, _errorConstants["default"].ERROR_CLASSNAME, hasError), "sessioncamexclude", sessionCamExclude));
      var describedById = hideErrors ? "".concat(formId, "-message") : "".concat(formId, "-").concat(input.name, "-message");

      // Checkboxes and Radio buttons render their own label
      var canRenderLabel = this.props.type !== 'checkbox' && this.props.type !== 'radio';
      return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
        className: (0, _classnames["default"])(_formFieldModule["default"][className], _defineProperty({}, _formFieldModule["default"].containerError, meta.submitFailed && hasError)),
        "data-testid": "form-field-container",
        "data-jlds": true,
        children: [canRenderLabel && label && /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
          className: _formFieldModule["default"].labelContainer,
          children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("label", {
            htmlFor: id,
            className: _formFieldModule["default"].label,
            "data-testid": "form-field-label",
            children: [label, !this.props.required && label.indexOf('(optional)') === -1 && /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
              children: [' ', /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
                children: "(optional)"
              })]
            })]
          }), labelHelperElement && /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
            className: (0, _classnames["default"])(_formFieldModule["default"].labelHelperElement, labelHelperClassName),
            "data-testid": "form-field-label-container",
            children: labelHelperElement
          })]
        }), !!description && /*#__PURE__*/(0, _jsxRuntime.jsx)("p", {
          className: _formFieldModule["default"].formFieldDescription,
          "data-testid": "form-field-description",
          children: description
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(FormElement, _objectSpread(_objectSpread({
          "data-testid": "form-field-element",
          id: id,
          className: inputClasses,
          inputClassName: inputClasses,
          inputWrapperClassName: inputWrapperClassName,
          label: label,
          meta: meta
        }, input), {}, {
          onChange: function onChange(e) {
            input.onChange(e);
            if (didYouMean) {
              _this2.processDidYouMean(e.target.value);
            }
          },
          onFocus: this.onFocus,
          onBlur: this.onBlur,
          ariaInvalid: hasError ? 'true' : 'false',
          ariaDescribedBy: hasError ? "".concat(describedById, "-error") : describedById,
          describedById: describedById,
          disabled: meta.submitting,
          submitButton: submitButton
        }, allOtherProps), input.name), showError && /*#__PURE__*/(0, _jsxRuntime.jsx)(_FormFieldErrorMessage["default"], {
          id: id,
          describedById: "".concat(describedById, "-error"),
          message: meta.error
        }), showHint && hint && /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
          id: describedById,
          className: _formFieldModule["default"].formFieldHint,
          "data-testid": "form-field-hint",
          children: hint
        }), instruction && /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
          id: describedById,
          className: _formFieldModule["default"].formFieldInstruction,
          "data-testid": "form-field-instruction",
          children: instruction
        }), didYouMean && suggestion && /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
          className: _formFieldModule["default"].formFieldSuggestion,
          children: ["Did you mean", ' ', /*#__PURE__*/(0, _jsxRuntime.jsx)(_Button.UnderlinedButton, {
            onClick: function onClick(e) {
              e.preventDefault();
              input.onChange({
                target: {
                  value: suggestion
                }
              });
              _this2.setState({
                suggestion: null
              });
            },
            children: suggestion
          }), "?"]
        }), extra]
      });
    }
  }]);
}(_react.PureComponent);
_defineProperty(FormField, "propTypes", {
  element: _propTypes["default"].oneOfType([_propTypes["default"].shape(), _propTypes["default"].func]),
  type: _propTypes["default"].string,
  id: _propTypes["default"].string.isRequired,
  label: _staticContentPropCheck["default"],
  className: _propTypes["default"].string,
  inputWrapperClassName: _propTypes["default"].string,
  placeholder: _propTypes["default"].string,
  maxLength: _propTypes["default"].number,
  hint: _staticContentPropCheck["default"],
  instruction: _staticContentPropCheck["default"],
  description: _propTypes["default"].elementType,
  autoFocus: _propTypes["default"].bool,
  sessionCamExclude: _propTypes["default"].bool,
  autoComplete: _propTypes["default"].string,
  readOnly: _propTypes["default"].bool,
  formId: _propTypes["default"].string,
  hideErrors: _propTypes["default"].bool,
  highlightError: _propTypes["default"].bool,
  submitButton: _propTypes["default"].node,
  extra: _propTypes["default"].node,
  didYouMean: _propTypes["default"].shape({
    set: _propTypes["default"].arrayOf(_propTypes["default"].string).isRequired,
    preprocess: _propTypes["default"].func,
    postprocess: _propTypes["default"].func,
    threshold: _propTypes["default"].number
  }),
  labelHelperElement: _propTypes["default"].element,
  labelHelperClassName: _propTypes["default"].string,
  // from redux-form
  input: _propTypes["default"].shape({
    onBlur: _propTypes["default"].func,
    onChange: _propTypes["default"].func,
    onFocus: _propTypes["default"].func,
    name: _propTypes["default"].string,
    value: _propTypes["default"].string
  }).isRequired,
  meta: _propTypes["default"].shape({
    active: _propTypes["default"].bool,
    touched: _propTypes["default"].bool,
    error: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].shape({})]),
    submitFailed: _propTypes["default"].bool,
    submitting: _propTypes["default"].bool
  })
});
_defineProperty(FormField, "defaultProps", {
  element: function element() {
    return null;
  },
  type: 'text',
  //
  label: '',
  className: 'fieldLarge',
  maxLength: undefined,
  inputWrapperClassName: undefined,
  hint: '',
  instruction: '',
  description: undefined,
  autoFocus: false,
  sessionCamExclude: true,
  autoComplete: 'on',
  placeholder: undefined,
  readOnly: false,
  formId: '',
  hideErrors: false,
  highlightError: false,
  submitButton: undefined,
  extra: undefined,
  didYouMean: undefined,
  labelHelperElement: undefined,
  labelHelperClassName: '',
  // from redux-form
  input: {},
  meta: {}
});
var _default = exports["default"] = FormField;